/**
 * Extract endpoint ID from current URL path
 * @returns {string|null} The endpoint ID or null if not found
 */
export function getEndpointId() {
    const path = window.location.pathname;
    const endpointId = path.substring(1); // Remove leading "/"
    
    // Basic UUID validation (loose check)
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    
    return endpointId && uuidRegex.test(endpointId) ? endpointId : null;
}

/**
 * Navigate to a specific endpoint
 * @param {string} endpointId - The endpoint ID to navigate to
 */
export function navigateToEndpoint(endpointId) {
    const newUrl = `/${endpointId}`;
    window.history.pushState({}, '', newUrl);
    
    // Dispatch custom event to notify components of route change
    window.dispatchEvent(new CustomEvent('routechange', { 
        detail: { endpointId } 
    }));
}

/**
 * Get the current page title based on endpoint
 * @param {string} endpointId - The endpoint ID
 * @returns {string} The page title
 */
export function getPageTitle(endpointId) {
    if (!endpointId) {
        return 'Chat UI - Select Endpoint';
    }
    return `Chat UI - ${endpointId.substring(0, 8)}...`;
}

/**
 * Initialize routing and handle browser back/forward
 */
export function initializeRouting() {
    // Handle browser back/forward buttons
    window.addEventListener('popstate', () => {
        const endpointId = getEndpointId();
        window.dispatchEvent(new CustomEvent('routechange', { 
            detail: { endpointId } 
        }));
    });
}
